import { Restricted } from 'containers/Restricted';

import { useFeatureAccessControl } from 'hooks/useFeatureAccessControl';

import { RECEIVERS_TITLE_TEST_ID } from './constants';
import { CreateReceiverButton } from './CreateReceiver/CreateReceiverButton';

type Props = {
  setKey: (key: number) => void;
};

export const ReceiversHeader = ({ setKey }: Props) => {
  const { isCreateReceiverEnabled } = useFeatureAccessControl();

  return (
    <div className="w-full items-center">
      <div className="flex justify-between">
        <div className="flex h-10 w-full flex-row justify-between">
          <div
            className="text-2xl font-medium"
            data-testid={RECEIVERS_TITLE_TEST_ID}
          >
            Receivers
          </div>
        </div>
        {isCreateReceiverEnabled && (
          <Restricted requiredPermission="receivers:manage">
            <CreateReceiverButton setKey={setKey} />
          </Restricted>
        )}
      </div>
    </div>
  );
};
